module.exports = __webpack_public_path__ + "static/hr_capabilities_9-927ce158fd0a75ddb939d572aa0edc6d.png";